export default "__VITE_ASSET__CnJOEsBd__"